<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Civilité</label>
          <select class="form-control" formControlName="civilite">
            <option value="">Sélectionner</option>
            <option *ngFor="let c of civilites" [value]="c.value">{{ c.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Nom <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="nom" placeholder="Nom">
          <span *ngIf="submit && f.nom.errors?.required" class="text-danger">Le nom est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Prénom</label>
          <input type="text" class="form-control" formControlName="prenom" placeholder="Prénom">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" placeholder="Email">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Téléphone</label>
          <input type="text" class="form-control" formControlName="telephone" placeholder="Téléphone">
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Adresse</label>
          <textarea class="form-control" formControlName="adresse" rows="2" placeholder="Adresse"></textarea>
        </div>
      </div>

      <!-- Champs personne morale -->
      <ng-container *ngIf="form.get('type').value === 'PERSONNE_MORALE'">
        <div class="col-md-6">
          <div class="form-group">
            <label>Raison sociale</label>
            <input type="text" class="form-control" formControlName="raisonSociale" placeholder="Raison sociale">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Représentant légal</label>
            <input type="text" class="form-control" formControlName="representantLegal" placeholder="Représentant légal">
          </div>
        </div>
      </ng-container>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nature pièce d'identité</label>
          <input type="text" class="form-control" formControlName="naturePiece" placeholder="CNI, Passeport, etc.">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>N° pièce d'identité</label>
          <input type="text" class="form-control" formControlName="numPiece" placeholder="Numéro">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>État</label>
          <select class="form-control" formControlName="etat">
            <option *ngFor="let e of etats" [value]="e.value">{{ e.label }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
